module.exports = __webpack_public_path__ + "img/SpawnerManagerSpawnType.d574b276.png";